import { render, staticRenderFns } from "./client-filter.vue?vue&type=template&id=4904ef50&scoped=true"
import script from "./client-filter.vue?vue&type=script&lang=js"
export * from "./client-filter.vue?vue&type=script&lang=js"
import style0 from "./client-filter.vue?vue&type=style&index=0&id=4904ef50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4904ef50",
  null
  
)

export default component.exports